import React, { FunctionComponent, SVGProps } from 'react';

export interface PayPalIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const PayPalIcon: FunctionComponent<PayPalIconProps> = ({
  className,
  ...props
}) => (
  <svg
    width="19"
    height="22"
    viewBox="0 0 19 22"
    className={className || ''}
    {...props}
  >
    <path
      fill="#179bd7"
      d="M17.12,5.59h0c-.71,4.74-4.01,6.7-8.15,6.63h-2.04c-.49,0-.9,.35-.98,.83h0l-1.05,6.51-.3,1.85c-.05,.31,.2,.59,.52,.59h3.63c.43,0,.79-.31,.86-.72l.04-.18,.68-4.25,.04-.23c.07-.42,.43-.72,.86-.72h.54c3.51,0,6.26-1.4,7.07-5.45,.42-2.17,.06-3.91-1.72-4.85Z"
    />
    <path
      fill="#253b80"
      d="M16.18,1.66c-1.04-1.16-2.92-1.66-5.32-1.66H3.89c-.49,0-.91,.35-.98,.83L0,18.88c-.06,.36,.22,.68,.59,.68H4.9s1.71-10.64,2.24-13.95c.07-.42,.44-.72,.86-.72,2.01,.09,6.53-.28,8.39,.4h0c.26,.09,.5,.19,.73,.3,.27-1.71,0-2.88-.95-3.93Z"
    />
    <path
      fill="#222d65"
      d="M16.16,5.21c-1.73-.55-6.3-.25-8.16-.32-.42,0-.8,.3-.86,.72l-1.16,7.22-.03,.21c.08-.48,.49-.83,.98-.83h2.04c4.14,.07,7.44-1.89,8.15-6.63-.29-.15-.63-.28-.96-.38Z"
    />
  </svg>
);

export default PayPalIcon;
